
angular
    .module('app')
    .directive("limitMaxDecimalNumbers", function() {
        return {
            link: function(scope, element, attributes) {
                element.on("keydown keyup", function(e) {

                    var numberParts = element.val().toString().split('.');

                    if (numberParts[1]) {
                        if (parseInt(numberParts[1].length) > Number(attributes.maxDecimalCount) &&
                            e.keyCode != 46 // delete
                            &&
                            e.keyCode != 8 // backspace
                        ) {
                            e.preventDefault();

                            element.val(numberParts[0] + '.' + numberParts[1].substr(0, numberParts[1].length - 1));
                        }
                    }
                });
            }
        };
    });
